export default function sanitizeOptionValue(value) {
  if (!value) return "";

  return value
    .replace(new RegExp(window.theme.discontinued_suffix, "i"), "")
    .trim();
}
